import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import "whatwg-fetch";
//import firebase from "../firebase";
import Prism from "prismjs";
import "prismjs/themes/prism.css";
import "prismjs/themes/prism-solarizedlight.css";

const RenderMd = props => {
  //   const { content } = props;
  const { mdContent } = props;
  //const [mdcontent, setMDContent] = useState();
  //const db = firebase.firestore();
  //const storage = firebase.storage();

  // useEffect(() => {
  //   //console.log("renderMd -> mdContent: ");

  //   // if (filename) {
  //   //   const storageRef = storage.refFromURL(filename);
  //   //   storageRef.getDownloadURL().then(url => {
  //   //     console.log("md url: ", url);

  //   //     fetch(url)
  //   //       .then(res => res.blob())
  //   //       .then(blob => {
  //   //         //console.log("blob: ", blob);

  //   //         const reader = new FileReader();
  //   //         reader.readAsText(blob);
  //   //         reader.onload = () => {
  //   //           //console.log("mdxContent: ", reader.result);
  //   //           setMDContent(reader.result);
  //   //         };
  //   //       });
  //   //   });
  //   // }
  // }, []);

  useEffect(() => {
    Prism.highlightAll();
  });

  return mdContent ? (
    <ReactMarkdown style={{ whiteSpace: "pre-wrap" }} source={mdContent} />
  ) : (
    ""
  );
};

export default RenderMd;
